import { gql } from '@apollo/client';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { PermissionFragment } from 'graphql/Permission/fragments/PermissionFragment';
/**
 * @fragment GroupFragment
 * @since 1.0.0
 */
export const GroupFragment = gql `
  fragment GroupFragment on Group {
    id
    title
    infos
    count
    tag
    createdAt
    updatedAt
    updatable
    deletable

    permissions {
      ...PermissionFragment
    }

    translations {
      id
      title
      infos
      createdAt
      updatedAt

      language {
        ...LanguageFragment
      }
    }
  }

  ${PermissionFragment}
  ${LanguageFragment}
`;
